var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"graphBody"},[_c('el-button',{attrs:{"type":"success"},on:{"click":_vm.ClickHandler}},[_vm._v(" Refresh map ")]),_c('div',{staticClass:"graphCy",attrs:{"id":"cy"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }